
export function Iframe(props) {
  // console.log({props})
  const url = props.url
  const height = props.height

  return <iframe src={url} height={height} width='100%' frameBorder='0' title='Iframe Content' />
}
